import { useAppDispatch, useAppSelector } from 'library/hooks/common';
import { selectShareOpen, shareEvent } from 'library/redux/events';

const useShare = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectShareOpen);

  const openShare = (id: number) => {
    dispatch(shareEvent({ id: id, isOpen: true }));
  };

  const closeShare = () => {
    dispatch(shareEvent({ id: 0, isOpen: false }));
  };

  return {
    isOpen,
    openShare,
    closeShare,
  };
};

export default useShare;
